export default __webpack_public_path__ + "img/tiktok.bee20bc38dea71647c762ecac53da831.svg";